<span class="overlay">
  <svg-icon src="small_rocket" preserveAspectRatio="none" [stretch]="true"></svg-icon>
  <span>{{ labelTranslationKey | translate }}</span>
</span>

@if (svgIconPath) {
  <svg-icon preserveAspectRatio="none" [src]="svgIconPath" [stretch]="true"></svg-icon>
}

<span>
  <ng-content></ng-content>
</span>
